// extracted by css-extract-rspack-plugin
export default {"ActionList_LinkItem":"LinkedBranches-module__ActionList_LinkItem__TduDo","ActionList_LeadingVisual":"LinkedBranches-module__ActionList_LeadingVisual__DDNWn"};